import { EThemeType } from "redux/reducers";

interface props{
  theme?: EThemeType,
  gptModal: boolean;
}
export const SearchIcon = (
    // {chatsidebar}:{chatsidebar?: boolean}
) => {
    return (

        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="28" viewBox="0 0 24 24" fill="none">
            <circle cx="11.7659" cy="11.7659" r="8.98856" stroke='#7A7880' strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18.0195 18.4844L21.5436 21.9992" stroke='#7A7880' strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export const HistorySearchIcon = ({theme, gptModal}:props)=>{
    return (
<svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
  <g clip-path="url(#clip0_2630_3086)">
    <path d="M11.375 6.1875C11.375 7.44258 10.9676 8.60195 10.2813 9.54258L13.743 13.007C14.0848 13.3488 14.0848 13.9039 13.743 14.2457C13.4012 14.5875 12.8461 14.5875 12.5043 14.2457L9.04258 10.7812C8.10195 11.4703 6.94258 11.875 5.6875 11.875C2.5457 11.875 0 9.3293 0 6.1875C0 3.0457 2.5457 0.5 5.6875 0.5C8.8293 0.5 11.375 3.0457 11.375 6.1875ZM5.6875 10.125C6.20458 10.125 6.7166 10.0232 7.19432 9.82528C7.67204 9.6274 8.1061 9.33736 8.47173 8.97173C8.83736 8.6061 9.1274 8.17204 9.32528 7.69432C9.52315 7.2166 9.625 6.70458 9.625 6.1875C9.625 5.67042 9.52315 5.1584 9.32528 4.68068C9.1274 4.20296 8.83736 3.7689 8.47173 3.40327C8.1061 3.03764 7.67204 2.7476 7.19432 2.54972C6.7166 2.35185 6.20458 2.25 5.6875 2.25C5.17042 2.25 4.6584 2.35185 4.18068 2.54972C3.70296 2.7476 3.2689 3.03764 2.90327 3.40327C2.53764 3.7689 2.2476 4.20296 2.04972 4.68068C1.85185 5.1584 1.75 5.67042 1.75 6.1875C1.75 6.70458 1.85185 7.2166 2.04972 7.69432C2.2476 8.17204 2.53764 8.6061 2.90327 8.97173C3.2689 9.33736 3.70296 9.6274 4.18068 9.82528C4.6584 10.0232 5.17042 10.125 5.6875 10.125Z" fill={theme==="dark" && gptModal ? "rgba(255, 255, 255, 0.3)": "#94A3B8"}/>
  </g>
  <defs>
    <clipPath id="clip0_2630_3086">
      <rect width="14" height="14" fill="white" transform="translate(0 0.5)"/>
    </clipPath>
  </defs>
</svg>
    )}